








import { Component, Vue, Prop } from "vue-property-decorator";
import { _isMobile } from "@/libs/tools";

@Component
export default class EpBanner extends Vue {
    @Prop() readonly item: any;
    private banner: string = "";
    mounted() {
        this.banner = _isMobile() ? this.item.mobile : this.item.pc;
    }
}
